module.exports = {"active":"pegi","hideTimerSeconds":5,"pegi":{"uri":"http://www.pegi.info/","assets":[{"uri":"https://web.ccpgamescdn.com/eveonlineassets/rating/pegi_12.gif","alt":"PEGI"},{"uri":"https://web.ccpgamescdn.com/eveonlineassets/rating/pegi_violence.gif","alt":"Violence"},{"uri":"https://web.ccpgamescdn.com/eveonlineassets/rating/pegi_online.gif","alt":"Online"}]}}


//////////////////
// WEBPACK FOOTER
// ./src/settings/rating.json
// module id = 1129
// module chunks = 0